import { render, staticRenderFns } from "./PersonProfile.vue?vue&type=template&id=972d5480&scoped=true"
import script from "./PersonProfile.vue?vue&type=script&lang=js"
export * from "./PersonProfile.vue?vue&type=script&lang=js"
import style0 from "./PersonProfile.vue?vue&type=style&index=0&id=972d5480&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972d5480",
  null
  
)

export default component.exports